import { PendingApprovalPageTemplate } from "./template";


export const PendingApprovalPage = () : JSX.Element => {
    return (
        <PendingApprovalPageTemplate />
    )
}